import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";

import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import CancellationRefund from "./pages/CancellationRefund";
import ContactUs from "./pages/ContactUs";
import Footer from "./components/Footer";
import AccountDelete from "./pages/AccountDelete";
import CookiePolicy from "./pages/CookiePolicy";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <Router>
      <Header />
      <div
        // style={{ padding: "20px" }}
        className="main-div"
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route
            path="/cancellation-and-refund"
            element={<CancellationRefund />}
          />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/account-delete" element={<AccountDelete />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </div>
      <Footer />
      <CookieConsent />
    </Router>
  );
}

export default App;
